import { Link } from "@/i18n/navigation";
import Image from "next/image";

export default function AbroadHotels({ item }) {
    return (
        <Link id={item.id} href={item.link} className="flex flex-col gap-4">
            <figure className="rounded-default relative w-full aspect-[5/3]">
                <Image
                    src={item.imageUrl}
                    alt={item.title}
                    fill
                    className="rounded-lg object-cover"
                    placeholder="blur"
                    blurDataURL="data:image/jpeg;base64,/9j/4AAQSkZJRgABAQAAAQABAAD/2wBDAAYEBQYFBAYGBQYHBwYIChAKCgkJChQODwwQFxQYGBcUFhYaHSUfGhsjHBYWICwgIyYnKSopGR8tMC0oMCUoKSj/2wBDAQcHBwoIChMKChMoGhYaKCgoKCgoKCgoKCgoKCgoKCgoKCgoKCgoKCgoKCgoKCgoKCgoKCgoKCgoKCgoKCgoKCj/wAARCAABAAEDASIAAhEBAxEB/8QAFQABAQAAAAAAAAAAAAAAAAAAAAv/xAAUEAEAAAAAAAAAAAAAAAAAAAAA/8QAFQEBAQAAAAAAAAAAAAAAAAAAAAX/xAAUEQEAAAAAAAAAAAAAAAAAAAAA/9oADAMBAAIRAxEAPwCdABmX/9k="
                    sizes="(max-width: 768px) 75vw, (max-width: 1024px) 38vw, 32vw"
                    onError={(e) => {
                        e.target.src = "/images/dummy/blog-placeholder.png";
                    }}
                />
            </figure>
            <div className="text-foreground text-lg font-semibold">
                {item.title}
            </div>
        </Link>
    )
}
